import { useCallback, useState } from 'react';

const INITIAL = { open: false, type: 'success', title: '', message: '', id: 0 };

export function useAdminToast() {
  const [toast, setToast] = useState(INITIAL);

  const showSuccess = useCallback((message, title = '操作成功') => {
    setToast((prev) => ({
      open: true,
      type: 'success',
      title,
      message,
      id: prev.id + 1,
    }));
  }, []);

  const showError = useCallback((message, title = '操作失败') => {
    setToast((prev) => ({
      open: true,
      type: 'error',
      title,
      message,
      id: prev.id + 1,
    }));
  }, []);

  const closeToast = useCallback(() => {
    setToast((prev) => ({ ...prev, open: false }));
  }, []);

  return { toast, showSuccess, showError, closeToast };
}
